import { css } from "@emotion/css";
import { borderWidth, fontSize, fontWeight, space, text, themeTokens } from "@octopusdeploy/design-system-tokens";

export const styles = {
    loading: css({
        display: "flex",
        justifyContent: "center",
    }),
    templateInfo: css({
        display: "flex",
        flexDirection: "column",
        gap: space[2],
    }),
    templateName: css({
        display: "flex",
        gap: space[6],
        alignItems: "center",
    }),
    truncatedTemplateName: css({
        whiteSpace: "nowrap",
    }),
    value: css({
        color: themeTokens.color.text.disabled,
        display: "flex",
        alignItems: "center",
        gap: space[8],
    }),
    missingValue: css({
        display: "flex",
        alignItems: "center",
        gap: space[8],
        color: themeTokens.color.text.secondary,
    }),
    sidebarContainer: css({
        paddingTop: space[12],
        overflowY: "auto",
    }),
    sidebar30Height: css({
        maxHeight: "137rem",
    }),
    sidebar50Height: css({
        maxHeight: "222rem",
    }),
    sidebar100Height: css({
        maxHeight: "430rem",
    }),
    sidebarRow: css({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: `${space[12]} 0 ${space[12]} ${space[16]}`,
        cursor: "pointer",
        "&:hover": {
            backgroundColor: themeTokens.color.background.primary.hover,
        },
        font: text.body.bold.large,
    }),
    sidebarFilter: css({
        display: "flex",
        paddingLeft: space[16],
        flexDirection: "row",
        alignItems: "center",
    }),
    sidebarNameContainer: css({
        display: "flex",
        alignItems: "center",
        gap: space[8],
    }),
    sidebarName: css({
        wordBreak: "break-word",
    }),
    sidebarSelectedName: css({
        color: themeTokens.color.text.selected,
    }),
    sidebarLabel: css({
        font: text.body.regular.small,
        color: themeTokens.color.text.tertiary,
    }),
    filterContainer: css({
        display: "flex",
        gap: space[8],
        padding: space[16],
        alignItems: "center",
    }),
    actionButtonsContainer: css({
        paddingRight: space[4],
    }),
    filterSidebar: css({
        whiteSpace: "nowrap",
        padding: `0 ${space[4]}`,
    }),
    filterMultiSelectContainer: css({
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: space[16],
        padding: space[16],
        flex: 1,
        overflowY: "auto",
        alignItems: "flex-end",
    }),
    filterItem: css({
        width: "250px",
        flex: "0 0 250px",
    }),
    cellLabel: css({
        font: text.body.regular.small,
        color: themeTokens.color.text.tertiary,
    }),
    toolbarIconsContainer: css({
        display: "inline-flex",
        alignItems: "center",
        gap: "1rem",
    }),
    variablesOverflowMenu: css({
        display: "flex",
        justifyContent: "flex-end",
    }),
    variableSetHeader: css({
        font: text.body.regular.small,
        color: themeTokens.color.text.primary,
        fontWeight: fontWeight[700],
        fontSize: fontSize["base"],
    }),
};

const tableBorder = `${borderWidth[1]} solid ${themeTokens.color.border.primary}`;

export const tenantVariablesDataTable = css({
    width: "100%",
    backgroundColor: themeTokens.color.background.primary.default,
    borderSpacing: 0,
    th: {
        padding: space[16],
        textAlign: "left",
        font: text.body.regular.medium,
        position: "relative",
        ":not(:last-child)": {
            ":after": {
                content: "''",
                position: "absolute",
                height: "50%",
                right: 0,
                top: "25%",
                borderRight: tableBorder,
            },
        },
    },
    td: {
        borderTop: tableBorder,
        font: text.body.regular.medium,
        padding: `0 ${space[16]} 0 ${space[16]}`,
        verticalAlign: "middle",
    },
});

export const pagingBarStyles = css({
    padding: "0 1rem",
});
